import http from "../ http-common";
import store  from "../store";

const getApibaseurl = () => {
  const state = store.getState();
  console.log("kjhgfdsadfgh uytfyguyi ",state.server?.API_BASE_URL );
  return state.server?.API_BASE_URL 
};

const API_BASE_URL = getApibaseurl() + "/admin";

class WebErrorsService {
  getErrors(page, limit) {
    var API_BASE_URL = getApibaseurl() + "/admin";
    return http.get(API_BASE_URL + "/userErrors", {
      params: {
        page,
        limit,
      },
    });
  }
}

export default new WebErrorsService();
